import { render, staticRenderFns } from "./DeliveryManagement.vue?vue&type=template&id=691ad0a6&scoped=true"
import script from "./DeliveryManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryManagement.vue?vue&type=script&lang=js"
import style0 from "./DeliveryManagement.vue?vue&type=style&index=0&id=691ad0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ad0a6",
  null
  
)

export default component.exports